import { FieldOperationsSensorsFieldName } from './field-operations-sensors.types';

export const FIELD_OPERATIONS_SENSORS_SORT_FIELD: Record<string, FieldOperationsSensorsFieldName> = {
  lastFieldOperationDate: FieldOperationsSensorsFieldName.LastFieldOperationDateUtc,
  commDeviceId: FieldOperationsSensorsFieldName.CommDeviceId,
  installationReason: FieldOperationsSensorsFieldName.InstallationReason,
  lastChangedBy: FieldOperationsSensorsFieldName.LastChangedBy
};
